import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'

import { styles } from './styles'
import Logo from '../../components/Logo'
import Title from '../../components/Title'
import { useDeepEffect } from '../../utils/hooks'

export const Hero = ({ history }) => {
  useDeepEffect(() => {
    localStorage.removeItem('location-data')
  }, [])

  const selectHero = (hero) => {
    // Go to register
    history.push(`/signup/${hero}`)
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            onClick={() => history.goBack()}>
            <BackIcon />
          </IconButton>
          <Logo />
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
      </AppBar>

      <Title name="รูปแบบการรับขยะรีไซเคิลของคุณ" />

      <main style={styles.main}>
        <div style={styles.buttonWrapper}>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            style={styles.button}
            onClick={() => selectHero('RECYCLE_SHOP')}>
            <div>ร้านรับซื้อขยะรีไซเคิล</div>
            <div>(Recycle Center)</div>
          </Button>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            style={styles.button}
            onClick={() => selectHero('SCOOTER')}>
            <div>รถรับซื้อขยะรีไซเคิล</div>
            <div>(Recycle Mobile)</div>
          </Button>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            style={styles.button}
            onClick={() => selectHero('DROP_POINT')}>
            <div>จุดรับบริจาคขยะรีไซเคิล</div>
            <div>(Recycle Donation Point)</div>
          </Button>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            style={styles.button}
            onClick={() => selectHero('POSTAL')}>
            <div>รับขยะรีไซเคิลทางพัสดุ</div>
            <div>(Recycle by Postal)</div>
          </Button>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            style={styles.button}
            onClick={() => selectHero('FACTORY')}>
            <div>โรงงานรีไซเคิล</div>
            <div>(Recycle Factory)</div>
          </Button>
        </div>
      </main>
    </React.Fragment>
  )
}

Hero.propTypes = {
  history: PropTypes.object.isRequired
}

export default Hero



// WEBPACK FOOTER //
// ./src/pages/Hero/index.js